module.exports = __webpack_public_path__ + "img/store5.0679b461.png";